export { default } from "./TableBody.js";
export { default as tableBodyClasses } from "./tableBodyClasses.js";
export * from "./tableBodyClasses.js";